/**
 * Initializer for fetching the users IP address
 */

module.exports = function() {
  $.getJSON("http://jsonip.com/?callback=?", function (data) {
    window.USER_IP_ADDRESS = data.ip;
  });
};



// WEBPACK FOOTER //
// ./initializers/location.js